module.exports = __webpack_public_path__ + "media/images/emblems/Gurtnellen_Wappen-813e683caa3c9abb8df78abfbbb9b54c.svg";